/**
 * Сторінка історії візитів клієнта
 * @component VisitHistoryPage
 * @file VisitHistoryPage.tsx
 * @path frontend/src/pages/VisitHistoryPage.tsx
 */

import React, { useState, useEffect } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { useAuth } from '../../contexts/AuthContext';
import './style.css';

const VisitHistoryPage: React.FC = () => {
  const { language } = useLanguage();
  const {} = useAuth();
  const [visits, _setVisits] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // TODO: Завантажити історію візитів з API
    setLoading(false);
  }, []);

  return (
    <div className="visit-history-page">
      <div className="page-header">
        <h1 className="page-title">
          {language === 'ua' ? 'Історія візитів' : 'Visit History'}
        </h1>
        <p className="page-subtitle">
          {language === 'ua'
            ? 'Перегляньте всі ваші попередні візити до майстрів'
            : 'View all your previous visits to masters'
          }
        </p>
      </div>

      <div className="page-content">
        {loading ? (
          <div className="loading-state">
            <p>{language === 'ua' ? 'Завантаження...' : 'Loading...'}</p>
          </div>
        ) : visits.length === 0 ? (
          <div className="empty-state">
            <i className="bi bi-clock-history"></i>
            <h3>
              {language === 'ua' ? 'Немає візитів' : 'No visits yet'}
            </h3>
            <p>
              {language === 'ua'
                ? 'Ваша історія візитів буде відображатися тут'
                : 'Your visit history will appear here'
              }
            </p>
          </div>
        ) : (
          <div className="visits-list">
            {visits.map((visit) => (
              <div key={visit.id} className="visit-card">
                <div className="visit-info">
                  <h4>{visit.serviceName}</h4>
                  <p>{visit.masterName}</p>
                  <p>{visit.date}</p>
                </div>
                <div className="visit-status">
                  <span className="status-badge">{visit.status}</span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default VisitHistoryPage;
